import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const gitrepoDiscoveryRouteRef = createRouteRef();

const repoDiscoveryPage = PageBlueprint.make({
  params: {
    path: '/gitrepo-discovery',
    noHeader: true,
    routeRef: gitrepoDiscoveryRouteRef,
    loader: () =>
      import('./components/RepoDiscovery/RepoDiscoveryComponent').then(
        m => <m.RepoDiscoveryComponent />,
      ),
  },
});

export default createFrontendPlugin({
  pluginId: 'gitrepo-discovery',
  extensions: [repoDiscoveryPage],
});
